/**
 * In-memory store for the last builder URL visited per section.
 *
 * When a user is working in a builder (e.g. /marketing/new?breakdown=...)
 * and navigates away, the full URL is saved here. When they click the
 * section link in the sidebar, SectionPage checks this store and redirects
 * them back to where they were — instead of dropping them at the reports listing.
 *
 * The store is intentionally in-memory (not sessionStorage) so it clears
 * on page refresh, matching the behaviour of the section data cache.
 */

const store = new Map<string, string>();

/** Get the last builder URL for a section, or null if none saved. */
export function getLastSectionUrl(section: string): string | null {
  return store.get(section) ?? null;
}

/** Save the current builder URL for a section. */
export function setLastSectionUrl(section: string, url: string): void {
  store.set(section, url);
}

/** Clear the saved builder URL for a section. */
export function clearLastSectionUrl(section: string): void {
  store.delete(section);
}
